import { useTranslate } from "src/i18n";
import { ILink } from "src/types";

export const useLandingPageLinks = (): ILink[] => {
  const { t } = useTranslate();
  return [
    {
      path: "/#advantages",
      name: t("header.link.advantages", "Преимущества"),
    },
    {
      path: "/#about",
      name: t("header.link.about", "О нас"),
    },
    {
      path: "/#reviews",
      name: t("header.link.reviews", "Отзывы"),
    },
    {
      path: "/#links",
      name: t("header.link.links", "Контакты"),
    },
  ];
};
